import { useRoute } from '@react-navigation/native';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { formatStartOf, localTime } from '@helpers';
import { useTimelineSelectors } from './useTimelineSelectors';

export const useTimelineRange = () => {
  const route = useRoute();
  const { timePeriod: selectedTime } = useHandleParams();
  const { featureFlags, selectedChartDate, selectedChartDateEnd } = useTimelineSelectors();

  const yearIsEnabled = FeatureFlagsAvailable('timeline-year', featureFlags);

  const startTime = route?.params?.date
    ? localTime(route?.params?.date).format()
    : selectedChartDate
    ? localTime(selectedChartDate).format()
    : localTime().startOf(formatStartOf(selectedTime)).format();

  const endTime = route?.params?.dateEnd
    ? localTime(route?.params?.dateEnd).format()
    : selectedChartDateEnd
    ? localTime(selectedChartDateEnd).format()
    : localTime(startTime)?.clone().add(1, selectedTime).startOf(formatStartOf(selectedTime)).format();

  return {
    startTime,
    endTime,
    yearIsEnabled,
  };
};
